import { useId } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";
import styles from "./AccordianComp.module.css";

function RichAnswer({ answer }) {
  if (!answer) {
    return null;
  }

  if (typeof answer !== "string") {
    return answer;
  }

  return <div className={styles.answerRichText} dangerouslySetInnerHTML={{ __html: answer }} />;
}

export default function AccordianComp({
  question,
  answer,
  isOpen = false,
  onToggle,
}) {
  const contentId = useId();

  return (
    <article className={`${styles.item} ${isOpen ? styles.itemOpen : ""}`}>
      <button
        type="button"
        className={styles.trigger}
        onClick={onToggle}
        aria-expanded={isOpen}
        aria-controls={contentId}
      >
        <span className={styles.question}>{question}</span>
        <span className={styles.iconWrap}>{isOpen ? <FaMinus /> : <FaPlus />}</span>
      </button>

      <div
        id={contentId}
        className={`${styles.content} ${isOpen ? styles.contentOpen : ""}`}
      >
        <div className={styles.answer}>
          <RichAnswer answer={answer} />
        </div>
      </div>
    </article>
  );
}
